import React, { createContext, useState } from "react";

export const TabsContext = createContext();

const TabsContextProvider = ({ children }) => {
  const [activeTab, setActiveTab] = useState("home");
  return (
    <TabsContext.Provider value={{ activeTab, setActiveTab }}>
      {children}
    </TabsContext.Provider>
  );
};

export default TabsContextProvider;
